// extracted by mini-css-extract-plugin
export default {"container":"CopyToPasteboard_container__+1uXL","input":"CopyToPasteboard_input__qSqh0","button":"CopyToPasteboard_button__rGqTe"};